module.exports = __webpack_public_path__ + "static/pod-image-3b6d28396f9abefa97b5263290f707e0.jpg";